import { render, staticRenderFns } from "./step-cost-vin-info.vue?vue&type=template&id=32b054a8"
import script from "./step-cost-vin-info.vue?vue&type=script&lang=ts"
export * from "./step-cost-vin-info.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports